<div class="slider" #slider>
	<ng-content select="carousel-slide"></ng-content>
</div>
